import { QRCodeSVG } from 'qrcode.react';
import { Box } from '@mui/material';

export const QRCode = () => {
  const params = new URLSearchParams(window.location.search);

  const value = params.get('data') || '';

  return (
    <Box sx={{ p: 2 }} margin={'8px'} textAlign={'center'}>
      <QRCodeSVG value={value} size={225} />
    </Box>
  );
};

export default QRCode;
